<template>
  <div>
    <div class="background"></div>
    <div class="mask"></div>
    <div class="login-container">
      <div class="login-form">
        <div class="login-form-main">
          <div class="login-form-logo"><a href="/"><img src="../../assets/image/slogon.png" alt=""></a></div>
          <div class="account-login" v-show="!wxlogin">
            <div class="account-slogon">欢迎登录</div>
            <div class="account-form">
              <el-input placeholder="请输入手机号" v-model="phone" class="form-input">
              </el-input>
              <el-input placeholder="请输入验证码" v-model="sms" class="form-input">
                <el-button slot="append" :disabled="disabled" @click="send">{{btnText}}</el-button>
              </el-input>
              <div class="btn-form">
                <el-button type="primary" :disabled="isloginning" @click="login" round>{{loginTxt}}</el-button>
              </div>
              <div class="btn-form">
                <el-button type="success" @click="handleWxlogin" round><i class="icon-wechat"></i>微信授权登录</el-button>
              </div>
              <div class="login-foot">
                <p class="span"><span>登录即为同意</span>
                  <el-link>《用户协议》</el-link>
                </p>
              </div>
            </div>

          </div>
          <div class="account-login thirdpart-login" v-show="wxlogin">
            <div class="account-form">
              <div class="thirdpart-login-qr" id="qr_login_container"></div>
              <p class="link"><a target="_blank" :href="'https://open.weixin.qq.com/connect/qrconnect?appid=wx765d69993b02dcfa&scope=snsapi_login&redirect_uri=http%3A%2F%2Fxingtanyipai.com%2Flogin?return_url='+(returnUrl?encodeURIComponent(returnUrl):'')+'&state=1&login_type=jssdk&self_redirect=default&styletype=&sizetype=&bgcolor=&rst=&style=black'">无法显示二维码？</a></p>
              <p class="link"><a href="javascript:;" @click="accountClick">使用帐号密码登录</a></p>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  Login
} from "../../model/login.js";
let login = new Login();
import utils from '../../utils/index';
export default {
  name: 'login',
  data() {
    return {
      returnUrl: this.$route.query.return_url,
      footerBar: false,
      headerBar: false,
      wxlogin: false,
      phone: "",
      disabled: false,
      btnText: '获取验证码',
      isOvertime: false,
      sms: '',
      isloginning: false,
    }
  },
  computed: {
    'loginTxt': function () {
      return this.isloginning ? "正在登录中" : "登陆"
    }
  },
  methods: {
    handleWxlogin() {
      this.wxlogin = true;
    },
    accountClick() {
      this.wxlogin = false;
    },
    wechatHandleClick() {
      //let ba64Css = "css代码base64编码";// 微信需要https的样式路径，这里将样式内容加密base64，可以避免使用https，如果你的网站是https的可以直接使用安官方文档使用css文件路径
      const appid = "wx765d69993b02dcfa";
      const redirect_uri = encodeURIComponent("http://xingtanyipai.com/login?return_url=" + encodeURIComponent(this.returnUrl));
      /* eslint-disable no-undef */
      new WxLogin({
        id: "qr_login_container", //div的id
        appid: appid,
        scope: "snsapi_login",//固定内容
        redirect_uri: redirect_uri, //回调地址
        // href: "http://*/static/UserCss/WeChart.css" //自定义样式链接，第三方可根据实际需求覆盖默认样式。        
        //href: "data:text/css;base64," + ba64Css,
        state: "1", //参数，可带可不带
        style: "black", //样式  提供"black"、"white"可选，默认为黑色文字描述
      });
    },
    handleUseInfo(res) {
      let _this = this;
      console.log(res)
      localStorage.setItem("openid", res.union_id);
      localStorage.setItem("_uuid", res.id);
      localStorage.setItem("user", JSON.stringify(res));
      localStorage.setItem("TOKEN", res.token);
      if (_this.returnUrl) {
        _this.$router.replace({ path: decodeURIComponent(_this.returnUrl) });
        //window.location.replace(decodeURIComponent(_this.returnUrl))
      } else {
        _this.$router.replace({ path: "/", replace: true });
      }
    },
    weixinRedirect() {
      let _this = this;
      let code = _this.$route.query.code;
      // let state = this.$route.query.state;
      if (code) {
        login.webLoginByCode(code).then((res) => {
          _this.handleUseInfo(res)
        })
        // this.$http("*/WeixinRedirect", data: wxTo).then((token) => {
        //   //登录成功，把token写入cookie
        //   //跳转到主页
        //   this.$router.replace({ path: "/", replace: true });
        // }).catch(error => {
        //   //保持当前页面
        //   this.$router.replace({ path: "/login", replace: true });
        // });
      }
    },
    getSMS() {
      let _this = this
      return new Promise(function (resolve, reject) {
        login.sendSMS({
          Phone: _this.phone
        }).then(() => {
          resolve()
        }, () => {
          reject();
        })
      })
    },
    timer() {
      let _this = this;
      if (_this.isOvertime) {
        return false;
      }
      let time = 60;
      var sendTimer = setInterval(function () {
        _this.isOvertime = true;
        time--;
        _this.btnText = '(' + (time) + 's)' + "重新发送";
        if (time < 0) {
          _this.isOvertime = false;
          _this.disabled = false;
          clearInterval(sendTimer);
          _this.btnText = "获取验证码";
        }
      }, 1000)
    },
    send() {
      let _this = this;
      if (!utils.isphone(_this.phone)) {
        _this.$message.error('请输入正确的手机号');
        return
      } else {
        _this.getSMS().then(() => {
          _this.disabled = true;
          _this.$message({
            message: '发送短信成功',
            type: 'success'
          });
          _this.timer();
        }, () => {
          _this.disabled = false;
        });
      }
    },
    login() {
      let _this = this;
      if (!utils.isphone(_this.phone)) {
        _this.$message.error('请输入正确的手机号');
        return
      } else if (_this.sms == '') {
        _this.$message.error('请输入验证码');
        return
      }
      _this.isloginning = true;
      login.appLogin({
        SMScode: _this.sms,
        phone: _this.phone,
        union_id: _this.phone,
        source: 20002
      }).then((res) => {
        _this.handleUseInfo(res.user)
      },()=>{
        _this.isloginning = false;
      })
    }
  },
  mounted() {
    this.wechatHandleClick()
  },
  created() {
    this.weixinRedirect()
    this.$emit('barTarget', { header: this.footerBar, footer: this.headerBar })
  },
  beforeRouteLeave(to, from, next) {
    this.$emit('barTarget', { header: true, footer: true })//如果离开把状态恢复
    next();// next()记得写不然不跳转
  },
  beforeRouteEnter(to, from, next) {
    console.log(to, '组件独享守卫beforeRouteUpdate第一个参数');
    console.log(from, '组件独享守beforeRouteUpdate卫第二个参数');
    console.log(next, '组件独享守beforeRouteUpdate卫第三个参数');
    next();// next()记得写不然不跳转
  }
}
</script>
<style lang="scss" scoped>
.background {
  position: absolute;
  right: 0px;
  top: 0px;
  bottom: 0px;
  left: 0px;
  background-size: cover;
  background-position: center;
  background-image: url(../../assets/bj1.png);
  background-attachment: fixed;
  z-index: 2;
}
.mask {
  position: absolute;
  right: 0px;
  top: 0px;
  bottom: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 3;
}
.login-container {
  position: relative;
  z-index: 5;
  max-width: 1056px;
  padding-left: 16px;
  padding-right: 16px;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
}
.login-form {
  padding-top: 96px;
  width: 380px;
  margin: auto;
  .login-form-logo {
    text-align: center;
    margin-bottom: 20px;
  }
  .account-login {
    padding: 30px 30px 16px;
    background-color: #fff;
  }
  .form-input {
    margin-bottom: 30px;
  }
  .account-slogon {
    color: #595959;
    font-size: 18px;
    text-align: center;
    margin-bottom: 20px;
    font-weight: bold;
  }
  .btn-form {
    text-align: center;
    margin-bottom: 20px;
  }
  .el-button {
    width: 100%;
  }
  .span {
    text-align: center;
    font-size: 14px;
    color: #999999;
    line-height: 25px;
    span {
      vertical-align: middle;
    }
  }
  .icon-wechat {
    display: inline-block;
    width: 16px;
    height: 16px;
    background-image: url(../../assets/image/wechat.png);
    background-repeat: no-repeat;
    background-size: 100%;
    vertical-align: middle;
    margin-right: 5px;
  }
  .thirdpart-login-qr {
    min-height: 150px;
    text-align: center;
  }

  .thirdpart-login {
    margin-bottom: 32px;
    min-height: 240px;
    position: relative;

    a {
      color: #096dd9;
      text-align: center;
    }
    .link {
      text-align: center;
    }
  }
}
</style>